const PORTAL_STYLES_ID = 'aiq-widget-portal-styles'

/**
 * UI-library components like Tooltip use FloatingPortal which renders to
 * document.body — outside both the Shadow DOM (embed) and the
 * .aiq-widget-scope wrapper (standalone). This means they lose access to
 * CSS variables and styled-components styles. We inject a minimal stylesheet
 * into the main document to cover these portaled elements.
 */
export function injectPortalStyles(): void {
  if (document.getElementById(PORTAL_STYLES_ID)) return
  const style = document.createElement('style')
  style.id = PORTAL_STYLES_ID
  style.textContent = `
    [data-testid="tooltip-content"] {
      background: #080808 !important;
      color: #ffffff !important;
      padding: 10px !important;
      border-radius: 8px !important;
      font-size: 14px !important;
      font-family: 'Manrope', sans-serif !important;
      z-index: 2147483640;
      max-width: 300px;
    }
    [data-testid="tooltip-content"] * {
      color: #ffffff !important;
    }
    [data-testid="tooltip-arrow"] {
      fill: #080808 !important;
    }
  `
  document.head.appendChild(style)
}

export function removePortalStyles(): void {
  document.getElementById(PORTAL_STYLES_ID)?.remove()
}
